import { FC, ReactNode, useState } from 'react';

type TooltipProps = {
  text: string;
  children: ReactNode;
  position?: string;
  containerClassNames?: string;
  tooltipClassNames?: string;
};

const Tooltip: FC<TooltipProps> = ({ text, children, position, containerClassNames, tooltipClassNames }) => {
  const [showTooltip, setShowTooltip] = useState<boolean>(false);

  return (
    <>
      <div
        className={`${containerClassNames ? containerClassNames : ''} relative`}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        onClick={() => setShowTooltip(false)}
        tabIndex={0}
        onKeyDown={() => {}}
        role="button"
      >
        {children}
        {showTooltip && (
          <div
            className={`absolute ${
              position ? position : '-left-2 top-1/2 -translate-x-[100%] -translate-y-1/2'
            } ${
              tooltipClassNames
                ? tooltipClassNames
                : 'bg-black text-[14px] w-auto whitespace-nowrap transform transition-transform duration-500 md:block hidden text-white py-1 px-2 rounded-md z-50'
            }`}
          >
            {text}
          </div>
        )}
      </div>
    </>
  );
};

export default Tooltip;
